<template>
  <div>
    <el-dialog
      title="发送范围"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="dialogBeforeClose"
    >
      <div class="send-code">
        <el-row>
          <el-col :span="6">
            <span>消息发送给：</span>
          </el-col>
          <el-col :span="18">
            <span>满足筛选条件的 {{ count }} 名客户</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <span>添加人：</span>
          </el-col>
          <el-col :span="18">
            <span v-if="groupmsgInfo.chat_range === 1">全部客户</span>
            <span v-else>
              <span
                v-if="groupmsgInfo.salesperson && groupmsgInfo.salesperson.length > 0"
              >{{ groupmsgInfo.salesperson[0].salesperson_name }} 等
                {{ groupmsgInfo.salesperson.length }} 人</span>
              <span v-else>未设置</span>
            </span>
          </el-col>
        </el-row>
        <template v-if="groupmsgInfo.chat_range === 2">
          <el-row>
            <el-col :span="6">
              <span>添加时间</span>
            </el-col>
            <el-col :span="18">
              <span
                v-if="groupmsgInfo.add_start_time_str"
              >{{ groupmsgInfo.add_start_time_str }} 至 {{ groupmsgInfo.add_end_time_str }}</span>
              <span v-else>未设置</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <span>客户标签</span>
            </el-col>
            <el-col :span="18">
              <span>筛选【满足以下任意标签】的客户</span>
              <div
                v-if="groupmsgInfo.tag && groupmsgInfo.tag.length > 0"
                class="babel-list-box"
              >
                <el-tag
                  v-for="item in groupmsgInfo.tag"
                  :key="item.id"
                  type="info"
                  :disable-transitions="false"
                >
                  {{ item.title }}
                </el-tag>
              </div>
              <div v-else>
                未设置
              </div>
            </el-col>
          </el-row>
        </template>
        <br>
        <el-row v-if="groupmsgInfo">
          <el-col :span="6">
            <span>客户身份</span>
          </el-col>
          <el-col :span="18">
            <span v-if="groupmsgInfo.member_status === 0">不限</span>
            <span v-if="groupmsgInfo.member_status === 1">会员</span>
            <span v-if="groupmsgInfo.member_status === 2">非会员</span>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'dialogVisible',
    event: 'dialogVisibleChange'
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    groupmsgInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    count: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      list: []
    }
  },
  methods: {
    dialogBeforeClose () {
      this.$emit('dialogVisibleChange', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.send-code {
  .el-row {
    min-height: 40px;
  }
}
.babel-list-box {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .el-tag {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
</style>
